    <section id="content">		
		<div class="form-group">
			<div class="card">
				
				<div class="cont">
					<div class="group">
						<div class="collapse-title" (click)="ele.class = ele.class == 'hideChildren' ? '' :  'hideChildren'">Opportunity History Log</div>
						<div class="collapse in show" id="userManagementGroup"  [ngClass]="{ hideChildren : ele.class == 'hideChildren' }" #ele>
							<div class="group-cont">
								<div class="table-responsive">
									<table class="table editable" id="history-table">
										<thead >
                                            <tr>
                                                <th>Action</th>
                                                <th>Action Date</th>
                                                <th>User</th>
												<th>Details</th>
                                            </tr>
										    <tr *ngIf="noRecords"> 
                                                <th style="text-align:center" colspan="3">No History Found</th>
                                            </tr>
                                            
										</thead>
										<tbody>                                            
                                            <tr *ngFor="let item of historyList; let i = index" >
                                                <td>
                                                    <input type="text" [value]="item?.action?.action" class="disabled">
                                                </td>
                                                <td>
                                                    <input type="text"  value="{{item?.actionDate  | date:'fullDate' }}" class="disabled">
                                                </td>
                                                <td>
                                                    <input type="text"  [value]="item?.userName" class="disabled">
                                                </td>
												<td>
                                                    <span style="white-space: pre-line;">{{item?.details}}</span>
                                                </td>
                                            </tr>
										</tbody>
									</table>
								</div>
							</div>
							<!-- /.group-cont -->
							<nav class="pagin">
                          	  	<ul class="pagination" id="createUserPagination">
                            	</ul>
                    		</nav>
						</div>
						
					</div>
					
					
					
				</div>
			</div>
		</div>
	</section>
	<div class="wizard-cotroles" 
	[hidden]="(hideComponent)">
		<div class="control prev" data-target="tab-3" [routerLink]="['/opportunities']">Prev</div>
	  </div>